module.exports = __webpack_public_path__ + "static/media/baseline-settings.e2016773.svg";